import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: 0,
};

const loader = createSlice({
  name: "loader",
  initialState,
  reducers: {
    fetching: (state) => {
      state.loading += 1;
    },
    fetched: (state) => {
      state.loading -= 1
    },
    reset: (state) => {
      state.loading = 0;
    },
  },
});

export const loaderActions = loader.actions;
export default loader.reducer;